import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import {
  Box,
  Button,
  Divider,
  FormControl,
  TextField
} from '@mui/material';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { useMutation } from 'react-fetching-library';
import { saveAs } from 'file-saver';

import { generateReportAction } from '../../../services/request';
import { formatDate } from '../../../services/functions';

export const TPayReport = () => {
  const { loading, mutate, error } = useMutation(generateReportAction);
  const today = new Date();
  const validationSchema = Yup.object({
    from_date: Yup.date().required('To pole nie może być puste'),
    to_date: Yup.date().required('To pole nie może być puste')
  });

  const initialValues = {
    from_date: formatDate(today),
    to_date: formatDate(today)
  };

  const handleSubmit = async values => {
    const { error, payload, headers, status } = await mutate(values);
    if (!error) {
      const blob = new Blob([payload], { type: 'application/vnd.ms-excel' });
      saveAs(blob, headers.get('content-disposition').slice(9));
    } else {
      console.error('err1');
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  return (
    <Box style={{ marginTop: 100, marginLeft: 200 }}>
      <form onSubmit={formik.handleSubmit}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <FormControl>
            <DatePicker
              inputFormat="yyyy-MM-dd"
              mask="____-__-__"
              label="Data Od"
              autoOk
              id="from_date"
              name="from_date"
              value={formik.values.from_date}
              onChange={val => formik.setFieldValue('from_date', formatDate(val))
              }
              error={
                formik.touched.from_date && Boolean(formik.errors.from_date)
              }
              helperText={formik.touched.from_date && formik.errors.from_date}
              renderInput={props => <TextField {...props} />}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
            />
          </FormControl>
          <FormControl>
            <DatePicker
              inputFormat="yyyy-MM-dd"
              mask="____-__-__"
              label="Data Do"
              autoOk
              id="to_date"
              name="to_date"
              value={formik.values.to_date}
              onChange={val => formik.setFieldValue('to_date', formatDate(val))
              }
              error={
                formik.touched.to_date && Boolean(formik.errors.to_date)
              }
              helperText={formik.touched.to_date && formik.errors.to_date}
              renderInput={props => <TextField {...props} />}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
            />
          </FormControl>
        </LocalizationProvider>
        <Divider style={{ width: 450, marginTop: 50, marginBottom: 20 }} />
        <Button
          color="primary"
          variant="contained"
          type="submit"
          style={{ marginBottom: 20 }}
        >
          Wygeneruj raport
        </Button>
      </form>
    </Box>
  );
};
